<template>
  <div class="feedback-form row">
    <div class="column small-12 large-4 text-center">
      <h3 class="heading heading--underline text-left mbl">
        Design № {{ designId }}
      </h3>
      <div class="tile tile--thumbnail tile--no-hover mbs">
        <img :src="displayImage" alt="Aperçu de design" />
      </div>
    </div>
    <div class="column small-12 large-8">
      <div v-for="(item, feedbackIndex) in feedback" :key="feedbackIndex">
        <h3 class="heading heading--underline mbl" v-if="feedbackIndex === 0">
          Commentaires
        </h3>
        <h3 class="heading heading--underline mbl mtl" v-if="feedbackIndex === 1">
          Commentaires plus anciens
        </h3>
        <div class="frame frame--padding-tight">
          <div class="row">
            <div class="column small-12 medium-12">
              <div class="row">
                <div class="column small-12 medium-11 large-10">
                  <p class="mbs">
                    <strong class="text-black text-large">Ratings</strong>
                  </p>
                  <div class="row align-justify">
                    <div class="column small-4">
                      <span class="text-medium">Qualité</span>
                    </div>
                    <div class="row small-8">
                      <div v-for="(n, index) in 5" :key="index">
                        <img
                          v-if="n <= item.quality"
                          :src="icons.fullStarIcon"
                          alt=""
                        />
                        <img v-else :src="icons.emptyStarIcon" alt="" />
                      </div>
                    </div>
                  </div>
                  <div class="row align-justify">
                    <div class="column small-4">
                      <span class="text-medium">La créativité</span>
                    </div>
                    <div class="row small-8">
                      <div v-for="(n, index) in 5" :key="index">
                        <img
                          v-if="n <= item.creativity"
                          :src="icons.fullStarIcon"
                          alt=""
                        />
                        <img v-else :src="icons.emptyStarIcon" alt="" />
                      </div>
                    </div>
                  </div>
                  <div class="row align-justify">
                    <div class="column small-4">
                      <span class="text-medium">Polices</span>
                    </div>
                    <div class="row small-8">
                      <div v-for="(n, index) in 5" :key="index">
                        <img
                          v-if="n <= item.fonts"
                          :src="icons.fullStarIcon"
                          alt=""
                        />
                        <img v-else :src="icons.emptyStarIcon" alt="" />
                      </div>
                    </div>
                  </div>
                  <div class="row align-justify">
                    <div class="column small-4">
                      <span class="text-medium">Couleurs</span>
                    </div>
                    <div class="row small-8">
                      <div v-for="(n, index) in 5" :key="index">
                        <img
                          v-if="n <= item.colors"
                          :src="icons.fullStarIcon"
                          alt=""
                        />
                        <img v-else :src="icons.emptyStarIcon" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column small-12 medium-11 large-10 mtm">
                  <p class="mbs">
                    <strong class="text-black text-large"
                      >Observations générales</strong
                    >
                    <br />
                    <span v-html="item.comments"></span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            class="horizontal-rule horizontal-rule--form-frame-tight"
            v-if="feedbackIndex === 0"
          >
            <hr class="hr hr--alt" />
          </div>
          <div class="form-stacking" v-if="feedbackIndex === 0">
            <div class="row align-center">
              <div class="column small-12 medium-shrink">
                <a :href="urls.sendMessageUrl" class="button primary">
                  Envoyer un message à ce client</a
                >
              </div>
              <div class="column small-12 medium-shrink">
                <a
                  :href="urls.submitLinkedDesignUrl"
                  class="button secondary hollow mbn"
                >
                  Soumettre une conception révisée
                </a>
              </div>
            </div>
          </div>
          <div
            class="horizontal-rule horizontal-rule--form-frame-tight"
            v-if="feedbackIndex > 0 && feedbackIndex < feedback.length"
          >
            <hr class="hr hr--alt" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    feedback: {
      type: Array,
      default: () => [],
    },
    icons: {
      type: Object,
      required: true,
    },
    urls: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      designId: this.feedback[0].designId,
      displayImage: this.feedback[0].thumbnailUrl,
    };
  },
  watch: {},
  mounted() {},
  methods: {},
};
</script>
